import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'activeConversation',
      'activeConversationHistory',
    ]),
    labels() {
      return !this.isHistory
        ? this.activeConversation.client.labels
        : this.activeConversationHistory.client.labels;
    },
  },
  methods: {
    textReplaced(text) {
      return text.replace(/\{\{(\p{Letter}|\w|\s)+\}\}/giu, (matches) => {
        const labelKey = matches.replace(/(\{|\})/g, '');
        const tag = this.labels.find(({ key }) => labelKey === key);

        if (tag) {
          return tag.value;
        }
        // TODO words reservadas
        // else if(RESERVADAS.includes(labelKey)) {
        //   return 'AGENTNAME';
        // }
        return matches;
      });
    },
  },
};
